import type { CatalogOption } from './types.ts'

export type EpisodeSeasonOrder = 'newest' | 'oldest'
export type EpisodeShowGroup = {
  series: string
  seasons: Array<{ season: number; episodes: CatalogOption[] }>
}

// Catalog identity remains untouched; grouping uses structured episode metadata.
export function groupEpisodeOptions(items: CatalogOption[], order: EpisodeSeasonOrder): EpisodeShowGroup[] {
  const shows = new Map<string, Map<number, CatalogOption[]>>()
  for (const item of items) {
    if (item.type !== 'episode' || !item.series || !Number.isInteger(item.season)) continue
    const seasons = shows.get(item.series) ?? new Map<number, CatalogOption[]>()
    const episodes = seasons.get(item.season!) ?? []
    if (!episodes.some((episode) => episode.id === item.id)) episodes.push(item)
    seasons.set(item.season!, episodes)
    shows.set(item.series, seasons)
  }
  return [...shows].sort(([left], [right]) => left.localeCompare(right)).map(([series, seasons]) => ({
    series,
    seasons: [...seasons].sort(([left], [right]) => order === 'newest' ? right - left : left - right).map(([season, episodes]) => ({
      season,
      episodes: [...episodes].sort((left, right) => (left.episode ?? Number.MAX_SAFE_INTEGER) - (right.episode ?? Number.MAX_SAFE_INTEGER)
        || (left.airDate ?? '').localeCompare(right.airDate ?? '') || left.id.localeCompare(right.id)),
    })),
  }))
}
